import { render, staticRenderFns } from "./cargoAiRecognitionDialog.vue?vue&type=template&id=53d31a3e&scoped=true&"
import script from "./cargoAiRecognitionDialog.vue?vue&type=script&lang=js&"
export * from "./cargoAiRecognitionDialog.vue?vue&type=script&lang=js&"
import style0 from "./cargoAiRecognitionDialog.vue?vue&type=style&index=0&id=53d31a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d31a3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d31a3e')) {
      api.createRecord('53d31a3e', component.options)
    } else {
      api.reload('53d31a3e', component.options)
    }
    module.hot.accept("./cargoAiRecognitionDialog.vue?vue&type=template&id=53d31a3e&scoped=true&", function () {
      api.rerender('53d31a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue"
export default component.exports